import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SmallSearchIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M7.09,-4.57204097e-07 C4.27193461,-0.00105213935 1.774187,1.81391153 0.904700043,4.49448723 C0.0352130836,7.17506294 0.992067076,10.1105811 3.27420645,11.7638607 C5.55634583,13.4171403 8.6438699,13.4115431 10.92,11.75 L13.59,14.41 L15,12.9999995 L12.33,10.33 C13.7712734,8.35369777 13.9810349,5.73559693 12.8728085,3.55502958 C11.7645821,1.37446223 9.52602519,0.000666430455 7.08,-4.57204097e-07 L7.09,-4.57204097e-07 Z M7.09000007,2 C8.69769517,2 10.1832668,2.85769513 10.9871144,4.24999998 C11.790962,5.64230484 11.790962,7.35769516 10.9871144,8.75000002 C10.1832668,10.1423049 8.69769517,11 7.09000007,11 C4.60471865,11 2.59000007,8.98528135 2.59000007,6.5 C2.59000007,4.01471865 4.60471865,2 7.09000007,2 L7.09000007,2 Z"
        data-testid="icon-smallSearch"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
